// Failed or malformed sources are unavailable, never a successful empty list.
export const readVehicleList = (response, key) => {
    const data = response?.data;
    const rows = Array.isArray(data) ? data : [key, 'data', 'items', 'results']
        .map((name) => data?.[name]).find(Array.isArray);
    if (!rows) throw new Error('VEHICLE_SOURCE_UNAVAILABLE');
    return rows;
};

export const withVehicleReadTimeout = async (promise, ms = 12000) => {
    let timer;
    try {
        return await Promise.race([
            promise,
            new Promise((_, reject) => {
                timer = setTimeout(() => reject(new Error('VEHICLE_READ_TIMEOUT')), ms);
            }),
        ]);
    } finally {
        clearTimeout(timer);
    }
};
